













import { Component, Prop, Vue, Watch, Emit } from 'vue-property-decorator';

@Component({})
export default class AuthMenuItem extends Vue {
  @Prop(Boolean) readonly viewOnly: boolean | undefined;
  @Prop(String) readonly path!: string;
  @Prop(String) readonly title!: string;
  @Prop(Function) readonly click!: any;
  @Prop() readonly name?: string;
  @Prop() notificationMenu?: any;

  active: boolean = false;

  get isNotification() {
    return (
      this.notificationMenu &&
      !!this.notificationMenu.length &&
      this.notificationMenu.includes(this.name || '')
    );
  }

  onClick(event: any) {
    if (this.viewOnly) {
      event.preventDefault();
      return false;
    }

    if (this.click) {
      return this.click();
    }

    event.preventDefault();

    if (this.path) {
      this.$router.push(this.path);
    }
  }

  @Watch('$route')
  onRouteChange() {
    this.active = this.$route.path === this.path;
  }

  mounted() {
    this.active = this.$route.path === this.path;
  }
}
